import { Form } from 'antd'
import styled from 'styled-components'

const StyledNoMarginFormItem = styled(Form.Item)`
  margin: 0px;
`

export default StyledNoMarginFormItem
